import { alpha } from "@mui/material";

export const getStyles = (theme) => ({
  container: {
    py: 3,
    px: 2
  },
  
  multipleOrdersAlert: {
    mb: 3,
    p: 2.5,
    bgcolor: alpha(theme.palette.info.main, 0.08),
    borderRadius: '12px',
    border: `2px solid ${alpha(theme.palette.info.main, 0.3)}`,
    boxShadow: `0 2px 12px ${alpha(theme.palette.info.main, 0.15)}`
  },
  
  alertBox: {
    mb: 3
  },
  
  card: {
    p: 3.5,
    height: 'fit-content',
    position: 'sticky',
    top: 20,
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
    }
  },
  
  tableContainer: {
    borderRadius: '12px',
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`
  },
  
  tableHead: {
    bgcolor: alpha(theme.palette.primary.main, 0.06),
    '& .MuiTableCell-head': {
      fontWeight: 600,
      fontSize: '0.9rem',
      color: theme.palette.primary.main,
      borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`
    }
  },
  
  tableRow: {
    transition: 'background-color 0.2s ease',
    "&:nth-of-type(odd)": {
      bgcolor: alpha(theme.palette.primary.main, 0.02)
    },
    "&:hover": { 
      bgcolor: alpha(theme.palette.primary.main, 0.06)
    }
  },
  
  mappingChip: (mappingNumber, colors) => ({
    fontWeight: 'bold',
    minWidth: '32px',
    height: '30px',
    bgcolor: colors.main,
    color: 'white',
    fontSize: '0.85rem',
    boxShadow: `0 2px 8px ${alpha(colors.main, 0.3)}`,
    transition: 'all 0.2s ease',
    '&:hover': {
      bgcolor: colors.main,
      transform: 'scale(1.1)',
      boxShadow: `0 4px 12px ${alpha(colors.main, 0.4)}`
    }
  }),
  
  mappingChipLight: (mappingNumber, colors) => ({
    fontWeight: 'bold',
    minWidth: '32px',
    height: '30px',
    fontSize: '0.85rem',
    bgcolor: colors.light,
    color: colors.main,
    border: `2px solid ${colors.main}`,
    boxShadow: `0 1px 4px ${alpha(colors.main, 0.2)}`,
    transition: 'all 0.2s ease',
    '&:hover': {
      bgcolor: alpha(colors.main, 0.2),
      transform: 'scale(1.1)',
      boxShadow: `0 2px 8px ${alpha(colors.main, 0.3)}`
    }
  }),
  
  totalsStack: {
    mt: 2.5,
    '& .MuiTypography-root': {
      transition: 'background-color 0.2s ease'
    }
  },
  
  successBg: (theme) => alpha(theme.palette.success.main, 0.12),
  errorBg: (theme) => alpha(theme.palette.error.main, 0.08),
  
  mappingPaper: {
    p: 3,
    bgcolor: alpha(theme.palette.info.main, 0.04),
    borderRadius: '16px',
    border: `2px solid ${alpha(theme.palette.info.main, 0.2)}`,
    boxShadow: `0 4px 16px ${alpha(theme.palette.info.main, 0.1)}`
  },
  
  mappingTableContainer: (isOrder) => ({
    borderRadius: '12px',
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    border: '3px solid',
    borderColor: isOrder ? 
      alpha(theme.palette.primary.main, 0.3) : 
      alpha(theme.palette.success.main, 0.3),
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: isOrder ? 
        theme.palette.primary.main : 
        theme.palette.success.main,
      boxShadow: isOrder ?
        `0 6px 24px ${alpha(theme.palette.primary.main, 0.2)}` :
        `0 6px 24px ${alpha(theme.palette.success.main, 0.2)}`
    }
  }),
  
  mappingTableHead: (theme, isOrder) => ({
    bgcolor: isOrder ? 
      alpha(theme.palette.primary.main, 0.12) : 
      alpha(theme.palette.success.main, 0.12),
    '& .MuiTableCell-head': {
      fontWeight: 600,
      fontSize: '0.9rem',
      color: isOrder ? theme.palette.primary.main : theme.palette.success.main,
      borderBottom: isOrder ?
        `2px solid ${alpha(theme.palette.primary.main, 0.3)}` :
        `2px solid ${alpha(theme.palette.success.main, 0.3)}`
    }
  }),
  
  mappingTableRow: (theme, isOrder, isClickable, isSelected, hasMapping, isMapped) => ({
    cursor: isClickable ? 'pointer' : 'default',
    opacity: !isOrder && !isClickable ? 0.5 : 1,
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    "&:nth-of-type(odd)": {
      bgcolor: isOrder ? 
        alpha(theme.palette.primary.main, 0.03) : 
        alpha(theme.palette.success.main, 0.03)
    },
    "&:hover": isClickable ? { 
      bgcolor: isOrder ? 
        alpha(theme.palette.primary.main, 0.08) : 
        alpha(theme.palette.success.main, 0.08)
    } : {},
    ...(isSelected ? {
      bgcolor: alpha(theme.palette.primary.main, 0.18),
      boxShadow: `inset 4px 0 0 ${theme.palette.primary.main}`,
      '&:hover': {
        bgcolor: alpha(theme.palette.primary.main, 0.22)
      }
    } : {}),
    ...(hasMapping && !isSelected ? {
      bgcolor: alpha(theme.palette.success.main, 0.1),
      boxShadow: `inset 4px 0 0 ${alpha(theme.palette.success.main, 0.5)}`
    } : {}),
    ...(isMapped ? {
      bgcolor: alpha(theme.palette.success.main, 0.15),
      boxShadow: `inset 4px 0 0 ${theme.palette.success.main}`
    } : {})
  }),

  actionButton: {
    borderRadius: '10px',
    fontWeight: 600,
    px: 3,
    py: 1.25,
    textTransform: 'none',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.18)'
    }
  },

  saveButton: {
    background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
    color: 'white',
    '&:hover': {
      background: 'linear-gradient(135deg, #1b5e20 0%, #0d3d10 100%)'
    },
    '&:disabled': {
      background: '#e0e0e0',
      color: '#9e9e9e'
    }
  },

  cancelButton: {
    borderColor: '#d1d5db',
    color: '#6b7280',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f3f4f6'
    }
  },

  clearButton: {
    borderColor: '#ef4444',
    color: '#ef4444',
    '&:hover': {
      borderColor: '#dc2626',
      backgroundColor: alpha('#ef4444', 0.08)
    }
  }
});